module.exports = __webpack_public_path__ + "img/ECI-logo wit.fc1e2fb7.svg";